var ApplicationAPI = require('../../../../common/api').Application
var FunderAPI = require('../../../../common/api').Funder

module.exports = function ($scope, $stateParams) {

  $scope.load = function () {
    if (!$stateParams.id) {
      throw new Error('no stateParams id');
      return;
    }

    ApplicationAPI.Get($stateParams.id, 'FunderApplicationDetailsView').then(function (result) {
      $scope.application = result;
      var perc = ($scope.application.totalRaised / ($scope.application.totalRequested + $scope.application.totalExternallyRaised)) * 100;
      $scope.application.percentage = Math.floor(perc);
    })

    FunderAPI.GetCurrentFunder("FunderDetailsView").then(function (result) {
      $scope.funder = result;
    });

    ApplicationAPI.GetQuestions($stateParams.id, false).then(function (result) {
      $scope.questions = result;
    })
  }

  $scope.addToShortList = function () {
    FunderAPI.AddApplicationToShortList($scope.funder.id, $stateParams.id).then(function () {
      $scope.application.isShortListed = true;
    });
  }

  $scope.removeFromShortList = function () {
    FunderAPI.RemoveApplicationFromShortList($scope.funder.id, $stateParams.id).then(function () {
      $scope.application.isShortListed = false;
    });
  }

  $scope.load();

}
